import { useState, useEffect, useCallback } from 'react';

export const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(false);

    const handleChange = useCallback((e) => {
        setIsMobile(e.matches);
    }, []);

    useEffect(() => {
        if (typeof window === 'undefined' || !window.matchMedia) {
            return;
        }

        const mediaQueryList = window.matchMedia('(max-width: 500px)');
        setIsMobile(mediaQueryList.matches);

        mediaQueryList.addEventListener('change', handleChange);
        return () => mediaQueryList.removeEventListener('change', handleChange);
    }, [handleChange]);

    return isMobile;
};